import React, { useEffect } from 'react';
import VipModal from '$/components/VipModal';
import { initLanguage } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import { NoSSR } from '@meitu/catalyze-next';
import { useCommonStore } from '@/store/useCommonStore';
import useIsMobile from '@/hooks/useIsMobile';
import { getEnv, navigate } from '@/common/agents';

export default function VipCard() {
  const toLogin = useCommonStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const isMobile = useIsMobile();
  useEffect(() => {
    initLanguage('en');
  }, []);

  return (
    <NoSSR>
      <VipModal
        mode="card"
        enableVip
        defaultOpen
        onCreateQrcodeBefore={async () => {
          if (isMobile) {
            const url = getEnv().ENV === 'development' ? '/--roboneo/download' : '/download';
            navigate({
              mode: 'url',
              url,
              replace: false,
            });
            return Promise.resolve(false);
          }
          const isUserLoggedIn = useOfficialStore.getState().isUserLoggedIn();
          if (!isUserLoggedIn) {
            await toLogin().then(() => {
              const baseUrl = getEnv().ENV === 'development' ? '/--roboneo/home' : '/home';
              sessionStorage.setItem('openVip', 'home_page');
              navigate({
                mode: 'url',
                url: baseUrl,
                replace: false,
              });
              initUserInfo();
            });
            return Promise.resolve(false);
          }
          return Promise.resolve(true);
        }}
      />
    </NoSSR>
  );
}
